module.exports = __webpack_public_path__ + "static/media/4.bbe85c9b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/moan/4.mp3
// module id = 480
// module chunks = 0